import { Component, Input, OnInit } from '@angular/core';

export enum PageTemplateTypes {
  legacy = 'legacy',
  equalSides = 'equalSides',
  twoColumns = 'twoColumns',
}

@Component({
  selector: 'mojo-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent implements OnInit {
  @Input() selectedTemplateType;
  @Input() pageHeader = false;
  templateTypes = PageTemplateTypes;

  ngOnInit() {
    if (!this.selectedTemplateType) {
      this.selectedTemplateType = 'legacy';
    }
  }
}
